import MobileDetect from 'mobile-detect';
import LoadingOverlay from '~/components/common/LoadingOverlay.vue';
export default {
  components: {
    LoadingOverlay
  },
  layout: 'password',
  data() {
    return {
      debug: false,
      debugRedirectTo: null,
      debugError: null,
      debugToken: null,
      debugFromApp: null
    };
  },
  head() {
    return {
      title: 'Members Area - EXTRA'
    };
  },
  mounted() {
    const {
      token: userToken,
      redirect: redirectURL,
      debug,
      from_app
    } = this.$route.query;
    console.log('route', this.$route);
    let redirectFallback = '/';
    this.debug = debug;
    (async () => {
      try {
        var _window;
        const platform = new MobileDetect(window.navigator.userAgent);
        const isMobile = ['AndroidOS', 'iOS', 'iPadOS'].includes(platform.os());
        const fromApp = !['no', 'false', '0'].includes(from_app === null || from_app === void 0 ? void 0 : from_app.toLowerCase()) && isMobile;
        if (fromApp) {
          redirectFallback = '/app/dismiss';
          this.debugFromApp = fromApp;
        }
        (_window = window) === null || _window === void 0 || _window.sessionStorage.setItem('EXTRA_FROM_APP', fromApp);
        console.log('EXTRA_FROM_APP', window.sessionStorage.getItem('EXTRA_FROM_APP'));
        const {
          token: memberToken
        } = await this.$axios.$post('/api/members/auth/user-token', {
          user_token: userToken
        });
        this.debugUserToken = userToken;
        this.debugMemberToken = memberToken;
        this.$cookies.set('members_token', memberToken, {
          path: '/'
        });
      } catch (err) {
        console.warn(err);
        this.debugError = err;
      } finally {
        this.redirect(redirectURL || redirectFallback);
      }
    })();
  },
  methods: {
    redirect(url) {
      if (!this.debug) {
        this.$router.push(url);
      } else {
        this.debugRedirectTo = url;
      }
    },
    debugContinue() {
      this.$router.push(this.debugRedirectTo);
    },
    async copy(e) {
      console.log('copied', await navigator.clipboard.writeText(e.target.innerHTML));
      setTimeout(() => {
        alert('Copied to clipboard');
      }, 100);
    }
  }
};